import { produce } from 'immer';
import { DraftState } from '@/types';
import { DraftActionTypes, DraftActions } from './types';

const INITIAL_STATE = {} as DraftState;

export const draftReducer = produce((draft: DraftState, action: DraftActions): DraftState => {
  switch (action.type) {
    case DraftActionTypes.SET_DRAFT:
      return action.draft;
    default:
      return draft;
  }
}, INITIAL_STATE);
